import { useIntl } from 'react-intl';

import type { WorkJourneyValidationTranslations } from '../utils/validateWorkJourneyForm';

const VALIDATION_PREFIX = 'workJourney.validation';

export const useWorkJourneyValidationTranslations = (): WorkJourneyValidationTranslations => {
  const intl = useIntl();

  return {
    nameRequired: intl.formatMessage({ id: `${VALIDATION_PREFIX}.nameRequired` }),
    workShiftRequired: intl.formatMessage({ id: `${VALIDATION_PREFIX}.workShiftRequired` }),
    workShiftIdRequired: intl.formatMessage({ id: `${VALIDATION_PREFIX}.workShiftIdRequired` }),
    startDateRequired: intl.formatMessage({ id: `${VALIDATION_PREFIX}.startDateRequired` }),
    supervisorsRequired: intl.formatMessage({ id: `${VALIDATION_PREFIX}.supervisorsRequired` }),
    invalidRequiredMembers: intl.formatMessage({
      id: `${VALIDATION_PREFIX}.invalidRequiredMembers`,
    }),
    locationRequired: intl.formatMessage({ id: `${VALIDATION_PREFIX}.locationRequired` }),
    locationTypeRequired: intl.formatMessage({
      id: `${VALIDATION_PREFIX}.locationTypeRequired`,
    }),
    breakMarkingTypeRequired: intl.formatMessage({
      id: `${VALIDATION_PREFIX}.breakMarkingTypeRequired`,
    }),
    breakStartTimeRequired: intl.formatMessage({
      id: `${VALIDATION_PREFIX}.breakStartTimeRequired`,
    }),
    toleranceTimeInvalid: intl.formatMessage({ id: `${VALIDATION_PREFIX}.toleranceTimeInvalid` }),
    earlyEndTimeInvalid: intl.formatMessage({ id: `${VALIDATION_PREFIX}.earlyEndTimeInvalid` }),
    shiftEndDateBeforeStart: intl.formatMessage({
      id: `${VALIDATION_PREFIX}.shiftEndDateBeforeStart`,
    }),
    journeyTypeRequired: intl.formatMessage({ id: `${VALIDATION_PREFIX}.journeyTypeRequired` }),
    workCircumstancesRequired: intl.formatMessage({
      id: `${VALIDATION_PREFIX}.workCircumstancesRequired`,
    }),
    membersMissingAddress: intl.formatMessage({
      id: 'users.select.tooltip.missingAddress',
    }),
    membersPending: intl.formatMessage({
      id: 'users.select.tooltip.pendingUser',
    }),
    membersInactive: intl.formatMessage({
      id: 'users.select.tooltip.inactiveUser',
    }),
  };
};
